import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { console_log, DataProvider } from 'src/providers/data/data';
import { CallapiService } from 'src/providers/rest/callapi.service';
import { DatePipe } from '@angular/common';
import { IDatePickerConfig } from 'ng2-date-picker';
import moment from 'moment';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
})

export class OrderListComponent implements OnInit {
  public order_date_month = '';
  public Today;
  public order_id = '';
  public order_type = '';
  public corporation_name = '';
  public order_staff = '';
  public order_coupon_status = '';
  public order_coupon_status0 = false;
  public order_coupon_status1 = false;
  public order_payment_status = '';
  public order_payment_status0 = false;
  public order_payment_status1 = false;
  public order_quotation = '';
  public order_quotation0 = false;
  public order_quotation1 = false;
  public order_invoice = '';
  public order_invoice0 = false;
  public order_invoice1 = false;
  public order_cancel_flg = '';
  public order_cancel_flg1 = false;
  public order_types = [
    { name: '本部', number: 1 },
    { name: '企業', number: 2 },
    { name: '個人', number: 3 }
  ];

  filteredItems = [];
  pages: number;
  pageSize: number = 10;
  pageNumber: number = 0;
  currentIndex: number = 1;
  items = [];
  pagesIndex: Array<number>;
  pageStart: number = 1;
  public corporation_form = 0;
  constructor(
    private router: Router,
    public data: DataProvider,
    public rest: CallapiService,
    private spinner: NgxSpinnerService,
    protected datepipe: DatePipe,
  ) {
  }

  ngOnInit() {
    this.data.menuPageTitle = 'contract-order-list';
    this.Today = new Date();
    this.rest.Get_Screenauth(this.data.uuid).subscribe(
      (res) => {
        var pages = res.data;
        const page = pages.find(page => page.pagename === 'contract-order-list');
        var bool = page ? page.auth === "F" : false;
        if (!bool) {
          this.router.navigate(['/']);
        }
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
    this.Search();
    this.corporation_form = JSON.parse(localStorage.getItem('loginData')).data.corporation_form;
    this.widthChanger('main-header', 360);
  }
  fillArray(): any {
    var obj = new Array();
    for (
      var index = this.pageStart;
      index < this.pageStart + this.pages;
      index++
    ) {
      obj.push(index);
    }
    return obj;
  }

  refreshItems() {
    this.items = this.filteredItems.slice(
      (this.currentIndex - 1) * this.pageSize,
      this.currentIndex * this.pageSize
    );
    this.pagesIndex = this.fillArray();
  }

  prevPage() {
    if (this.currentIndex > 1) {
      this.currentIndex--;
    }
    if (this.currentIndex < this.pageStart) {
      this.pageStart = this.currentIndex;
    }
    this.refreshItems();
  }

  nextPage() {
    if (this.currentIndex < this.pageNumber) {
      this.currentIndex++;
    }
    if (this.currentIndex >= this.pageStart + this.pages) {
      this.pageStart = this.currentIndex - this.pages + 1;
    }
    this.refreshItems();
  }

  setPage(index: number) {
    this.currentIndex = index;
    this.refreshItems();
  }

  selectedRadios(id) {
    this.pageSize = id;
    this.currentIndex = 1;
    this.pageStart = 1;
    this.pages = 6;

    this.pageNumber = parseInt('' + this.filteredItems.length / this.pageSize);
    if (this.filteredItems.length % this.pageSize != 0) {
      this.pageNumber++;
    }

    if (this.pageNumber < this.pages) {
      this.pages = this.pageNumber;
    }
    this.refreshItems();
  }

  Search() {
    this.order_coupon_status = this.checkBox(this.order_coupon_status0, this.order_coupon_status1);
    this.order_payment_status = this.checkBox(this.order_payment_status0, this.order_payment_status1);
    this.order_quotation = this.checkBox(this.order_quotation0, this.order_quotation1);
    this.order_invoice = this.checkBox(this.order_invoice0, this.order_invoice1);
    this.order_cancel_flg = this.order_cancel_flg1 ? "1" : "";
    this.spinner.show();
    this.rest.Get_CouponOrder(
      this.data.uuid,
      this.data.scope,
      this.order_date_month,
      this.order_id,
      this.order_type,
      this.corporation_name,
      this.order_staff,
      this.order_coupon_status,
      this.order_payment_status,
      this.order_quotation,
      this.order_invoice,
      this.order_cancel_flg
    ).subscribe(
      (res)=>{
        console_log(res);
        this.filteredItems = res.data.CouponOrder;
        if (res.code == 'W000001') {
          document.getElementById('limit10000').style.display = 'block';
        } else {
          document.getElementById('limit10000').style.display = 'none';
        }
        this.currentIndex = 1;
        this.pageStart = 1;
        this.pages = 6;

        this.pageNumber = parseInt(
          '' + this.filteredItems.length / this.pageSize
        );
        if (this.filteredItems.length % this.pageSize != 0) {
          this.pageNumber++;
        }
        if (this.pageNumber < this.pages) {
          this.pages = this.pageNumber;
        }
        this.refreshItems();
        this.spinner.hide();
      },
      (err)=>{
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/contract-err', {code: err.error.error.code}]);
      }
    );
  }

  codeList(list) {
    console_log(list);
    if (list.coupon_flg == '1') {
      this.router.navigate(['/contract-code-list', {order_id: list.order_id}]);
    }
  }

  pdf_download(uuid) {
  }

  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          header.style.minWidth = width.toString() + 'px';
      }
  }

  getOrderTypeName(number: string): string | undefined {
    const orderType = this.order_types.find(type => type.number === Number(number));
    return orderType ? orderType.name : undefined;
  }
  parse(e) {
    return parseFloat(e).toLocaleString('en');
  }
  getPaymentStatusName(number: string){
    return number == '0' ? '未入金' : '入金済み';
  }
  getCouponflgName(number: string){
    return number == '0' ? '未発行' : '発行済み';
  }
  checkBox(check0, check1) {
    var value = "ALL"
    if (check0 && check1) {
      value = "ALL"
    } else if (check0) {
      value = "0";
    } else if (check1) {
      value = "1"
    }
    return value;
  }
  csvOutput(){
    this.spinner.show();
    this.rest.Create_OrdersCsvFile(
      this.data.uuid,
      this.data.scope,
      this.order_date_month,
      this.order_id,
      this.order_type,
      this.corporation_name,
      this.order_staff,
      this.order_coupon_status,
      this.order_payment_status,
      this.order_quotation,
      this.order_invoice,
      this.order_cancel_flg
    ).subscribe(
      (res) => {
        console_log(res);
        const link = document.createElement('a');
        link.href = res.data.s3url;
        link.click();
        this.spinner.hide();
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/contract-err', {code: err.error.error.code}]);
      }
    );
  }
  config: IDatePickerConfig = {
    format: 'yyyy-MM',
    yearFormat: 'yyyy' + '年',
    disableKeypress: true,
    onOpenDelay: 0,
    closeOnSelect: true,
    monthFormat: 'MM',
    monthBtnFormat: 'MM' + '月',
  }
  GoToCurrent(event) {
    event = moment().subtract(0, 'days');
    this.order_date_month = event;
  }

  onDateChange(event: any): void {
    console_log(event);
    this.order_date_month = event;
    if(this.order_date_month != ''){
      document.getElementById('clear1').style.display = 'block';
      document.getElementById('calendar1').style.display = 'none';
    }else{
      document.getElementById('clear1').style.display = 'none';
      document.getElementById('calendar1').style.display = 'block';
    }
  }

  clearDate() {
    this.order_date_month = '';
    if(this.order_date_month == ''){
      document.getElementById('clear1').style.display = 'none';
      document.getElementById('calendar1').style.display = 'block';
    }
  }
  
  pdf(id, orderID, flg) {
    if (id == 1 && flg == '1') {
      this.spinner.show();
      this.rest.Download_Quotation(this.data.uuid, orderID).subscribe(
        (res) => {
          if (res.code == 'S000001') {
            this.spinner.hide();
            window.open(res.data.s3url, '_blank', '');
          }
        },
        (err) => {
          console_log(err);
          this.spinner.hide();
          this.router.navigate(['/contract-err', {code: err.error.error.code}]);
        }
      );
    }
    if (id == 2 && flg == '1') {
      this.spinner.show();
      this.rest.Download_Invoice(this.data.uuid, orderID).subscribe(
        (res) => {
          if (res.code == 'S000001') {
            this.spinner.hide();
            window.open(res.data.s3url, '_blank', '');
          }
        },
        (err) => {
          console_log(err);
          this.spinner.hide();
          this.router.navigate(['/contract-err', {code: err.error.error.code}]);
        }
      );
    }
  }
}